import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Badge, Box, IconButton, Popover, Stack, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useKeycloak } from "@react-keycloak/web";
import { useAtomValue } from "jotai";
import React, { useCallback, useState } from "react";
import { APP_NOTIFICATION_COMPONENT_STATIC_TEXTS } from "../../constants";
import useNotificationService from "../../services/useNotificationService";
import { baseAtom } from "../../stores/jotai/base";
import { useGetFindings } from "../../tanstackQuery/queries/findings";
import OverlayTitle from "../generics/components/overlay-title";
import MarkAllAsReadButton from "./MarkAllAsReadButton";
import NotificationListener from "./notification-listener";
import NotificationUnreadFilterSwitch from "./NotificationUnreadFilterSwitch";

const NotificationPopover = (props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);
  const {
    isMarkingAllNotificationsAsRead,
    notifications,
    unseenNotifications,
    handleMarkAllNotificationsAsRead
  } = useNotificationService({ notificationData: props?.notifications });
  const base = useAtomValue(baseAtom);
  const { org } = base;
  const isNotificationPopoverOpen = !!org && !!anchorEl;
  const theme = useTheme();
  const { keycloak } = useKeycloak();
  const { findings: findingsData } = useGetFindings(
    { accessToken: keycloak?.token },
    { groupID: base?.team?.groupID, userID: base?.user?.userID, isMetaInsightEnabled: true },
    { enabled: anchorEl ? true : false }
  );

  const handlePopoverOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationIconClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      handlePopoverOpen(event);
    },
    [handlePopoverOpen]
  );

  return (
    <>
      <Tooltip
        title={APP_NOTIFICATION_COMPONENT_STATIC_TEXTS.ICON_BUTTON.TOOLTIP}
      >
        <Badge
          classes={{ badge: "appbar-nav-item-badge white-badge-text" }}
          badgeContent={unseenNotifications}
          color="error"
          sx={{
            margin: "0 12px !important"
          }}
        >
          <IconButton
            sx={{
              border: `1px solid ${theme?.custom?.borderGrey}`,
              borderRadius: "4px",
              padding: "4px",
              ":hover": {
                color: theme?.custom?.mainButtonHighlight,
                border: `1px solid ${theme?.custom?.mainButtonHighlight}`
              }
            }}
            onClick={handleNotificationIconClick}
          >
            <NotificationsOutlinedIcon />
          </IconButton>
        </Badge>
      </Tooltip>
      <Popover
        open={isNotificationPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        keepMounted={true}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        slotProps={{
          root: {
            sx: {
              zIndex: 10
            }
          },
          paper: {
            sx: {
              overflow: "hidden",
              width: "450px",
              ".NotificationListScroller": {
                maxHeight: "calc(100vh - 190pt)"
              }
            }
          }
        }}
        sx={{
          margin: "-8px 0 0 -8px"
        }}
      >
        {/* <OverlayTitle
                    
                    sx={{
                        backgroundColor: theme?.custom?.white,
                        color: theme?.custom?.text,
                        borderBottom: `thin solid ${theme?.custom?.disabledColor}`,
                        padding: "10px 14px",
                        
                        

                    }}
                    title={
                       
                    }
                /> */}

        <Box
          sx={{
            backgroundColor: theme?.custom?.white,
            color: theme?.custom?.text,
            borderBottom: `thin solid ${theme?.custom?.disabledColor}`,
            padding: "10px 14px"
          }}
        >
          <Stack direction="row" sx={{ alignItems: "center" }}>
            <Box
              component="span"
              sx={{
                fontSize: "20px",
                fontWeight: 700
              }}
            >
              {APP_NOTIFICATION_COMPONENT_STATIC_TEXTS.POPOVER.TITLE}
            </Box>
            <NotificationUnreadFilterSwitch sx={{ marginLeft: "auto" }} />
            <MarkAllAsReadButton
              isMarkingAllNotificationsAsRead={isMarkingAllNotificationsAsRead}
              onMarkAllAsRead={handleMarkAllNotificationsAsRead}
            />
          </Stack>
        </Box>

        <NotificationListener
          closeNotificationPopover={handlePopoverClose}
          notifications={notifications}
          isNotificationPopoverOpen={isNotificationPopoverOpen}
          findings={findingsData?.findings}
        />
      </Popover>
    </>
  );
};

export default NotificationPopover;
